<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Adicionar Usuário</div>
            </div>
            <div class="card-body">
              <hr />
              <br />
              <div class="row">
                <div class="col-md-12">
                  <form action>
                    <div class="form-row">
                      <div class="form-group col-md-4">
                        <label for="Name">
                          <span class="required">*</span> Nome:
                        </label>
                        <input
                          autocomplete="new-password"
                          type="text"
                          id="Name"
                          class="form-control"
                          v-model="users.name"
                          placeholder=""
                        />
                      </div>
                      <div class="form-group col-md-4">
                        <label for="Email">
                          <span class="required">*</span> Login:
                        </label>
                        <input
                          autocomplete="new-password"
                          class="form-control"
                          id="Email"
                          placeholder=""
                          type="text"
                          v-model="users.login"
                        />
                      </div>

                      <div class="col-md-3">
                        <label>CPF</label>
                        <input
                          v-model="users.cpf"
                          type="text"
                          class="form-control"
                          v-mask="'999.999.999-99'"
                        />
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-3">
                        <label><span class="required">*</span> Agência</label>
                        <v-select
                          v-model="users.central_id"
                          :options="centrals"
                          :reduce="(central) => central.id"
                          label="fantasy_name"
                          multiple
                          @input="getUnitsByCentral"
                        ></v-select>
                      </div>
                      <div class="form-group col-md-3">
                        <label for="Name"> E-mail: </label>
                        <input
                          autocomplete="new-password"
                          type="text"
                          id="Name"
                          class="form-control"
                          v-model="users.email"
                          placeholder=""
                        />
                      </div>
                      <div class="form-group col-md-2">
                        <label for="inputUser">
                          <span class="required">*</span> Nível de acesso:
                        </label>
                        <select
                          v-model="users.access_nivel"
                          class="form-control"
                        >
                          <option v-if="canAssignNivel(1)" :value="1" :key="1">
                            Usuário Padrão
                          </option>
                          <option v-if="canAssignNivel(3)" :value="3" :key="3">
                            Editor de Desfecho
                          </option>
                          <option v-if="canAssignNivel(2)" :value="2" :key="2">
                            Administrador Central
                          </option>
                          <option v-if="canAssignNivel(6)" :value="6" :key="6">
                            Administrador
                          </option>
                        </select>
                      </div>
                      <div class="form-group col-md-3">
                        <label for="Cellphone">Unidade:</label>
                        <v-select
                          v-model="users.unit_id"
                          :options="units"
                          :reduce="(unit) => unit.id"
                          label="unit_name"
                          multiple
                        ></v-select>
                      </div>
                      <div class="form-group col-md-1">
                        <label>Status do Usuário</label><br />
                        <toggle-button
                          v-model="users.status"
                          color="#15488A"
                          :height="25"
                        />
                        &nbsp;<b>{{ users.status ? "Ativo" : "Inativo" }}</b>
                      </div>
                    </div>
                    <div class="row" v-if="$route.params.id">
                      <div class="col-md-12 mb-2">
                        <button
                          type="button"
                          class="btn btn-add"
                          @click="toggleFormSenha"
                        >
                          <i class="fas fa-key"></i> Alterar Senha
                        </button>
                      </div>
                    </div>
                    <div class="form-row" v-if="change_password">
                      <div class="form-group col-md-6">
                        <label for="password">
                          <span class="required">*</span> Senha:
                        </label>
                        <input
                          autocomplete="new-password"
                          type="password"
                          id="password"
                          class="form-control"
                          v-model="users.password"
                          placeholder=""
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <label for="confirmPassword">
                          <span class="required">*</span> Confirme a senha:
                        </label>
                        <input
                          autocomplete="new-password"
                          class="form-control"
                          id="confirmPassword"
                          placeholder=""
                          type="password"
                          v-model="users.password_confirmation"
                        />
                      </div>
                    </div>

                    <div class="form-group">
                      <label for="userPic"> Foto do Perfil </label>
                      <div class="user-img">
                        <img
                          v-if="previewImage"
                          :src="previewImage"
                          class="photo"
                        />
                        <img v-else class="photo" />
                      </div>
                      <input
                        type="file"
                        class=""
                        id="userPic"
                        accept="image/*"
                        name="userPic"
                        @change="uploadImage"
                        placeholder
                      />
                    </div>
                    <span class="required_fields">
                      <span class="required">*</span>
                      <strong>Campos obrigatórios</strong>
                    </span>
                    <div class="block text-right">
                      <router-link to="/users" class="btn btn-back mr-1">
                        <i class="fa fa-arrow-left"></i> Voltar
                      </router-link>
                      <a class="btn btn-add" @click="save">
                        Salvar
                        <i class="fa fa-save"></i>
                      </a>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  name: "imageUpload",
  data() {
    return {
      change_password: true,
      users: {
        name: "",
        login: "",
        access_nivel: "",
        password: "",
        password_confirmation: "",
        cpf: "",
        status: 1,
        unit_id: [],
        central_id: [],
      },
      companies: {},
      units: [],
      perfil_usuarios: [],
      centrals: [],
      errors: undefined,
      previewImage: null,
    };
  },
  computed: {},
  methods: {
    // Hierarquia de privilégio: 6 (Admin Global) > 2 (Admin Central) > 3 (Editor Desfecho) > 1 (Usuário Padrão).
    // Admin global atribui qualquer nível; os demais só níveis estritamente abaixo do próprio.
    canAssignNivel(nivel) {
      const me = this.$store.state.user.access_nivel;
      if (me == 6) return true;
      const rank = { 1: 1, 3: 2, 2: 3, 6: 4 };
      return (rank[nivel] || 0) < (rank[me] || 0);
    },
    toggleFormSenha() {
      const self = this;
      if (self.change_password) {
        self.change_password = false;
      } else {
        self.change_password = true;
      }
    },
    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      let photo = document.getElementById("userPic");

      fd.append("name", self.users.name);
      fd.append("login", self.users.login);
      fd.append("access_nivel", self.users.access_nivel);
      fd.append("email", self.users.email ? self.users.email : "");
      fd.append("cpf", self.users.cpf ? self.users.cpf : "");

      fd.append("password", self.users.password);
      fd.append("password_confirmation", self.users.password_confirmation);
      fd.append("status", self.users.status ? 1 : 0);

      if (Array.isArray(self.users.unit_id)) {
        self.users.unit_id.forEach((id, index) => {
          fd.append(`unit_id[${index}]`, id);
        });
      } else if (self.users.unit_id) {
        fd.append("unit_id[0]", self.users.unit_id);
      }
      if (Array.isArray(self.users.central_id)) {
        self.users.central_id.forEach((id, index) => {
          fd.append(`central_id[${index}]`, id);
        });
      } else if (self.users.central_id) {
        fd.append("central_id[0]", self.users.central_id);
      }

      fd.append("_method", "POST");

      fd.append("photo", photo.files[0] ? photo.files[0] : "");

      if (self.users.id) {
        fd.append("id", self.users.id);
        fd.append("_method", "PUT");
      }

      return fd;
    },
    save: function () {
      const self = this;
      let api = self.$store.state.api + "users";

      let fd = self.makeFormData();

      if (self.users.id) {
        api += "/" + self.users.id;
      }

      axios
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/users");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getUsers(id) {
      const self = this;
      const api =
        self.$store.state.api + "users/" + id + "?with[]=units&with[]=centrals";
      axios
        .get(api)
        .then((response) => {
          self.users = response.data.data[0];
          self.users.password = "";
          self.change_password = false;

          if (self.users.units && self.users.units.length > 0) {
            this.$set(
              this.users,
              "unit_id",
              self.users.units.map((unit) => unit.id)
            );
          } else {
            this.$set(this.users, "unit_id", []);
          }
          if (self.users.centrals && self.users.centrals.length > 0) {
            this.$set(
              this.users,
              "central_id",
              self.users.centrals.map((central) => central.id)
            );
          } else {
            this.$set(this.users, "central_id", []);
          }
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getCentrals: function (id) {
      const self = this;
      const api = self.$store.state.api + "centrals?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.centrals = response.data.data.sort((a, b) =>
            a.name.localeCompare(b.name)
          );
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getUnits: function () {
      const self = this;
      const api = self.$store.state.api + "units?paginated=false";

      axios
        .get(api)
        .then((response) => {
          const data = Array.isArray(response.data)
            ? response.data
            : response.data.data;

          self.units = data.sort((a, b) =>
            a.unit_name.localeCompare(b.unit_name)
          );
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getUnitsByCentral: function () {
      const self = this;
      if (!self.users.central_id || self.users.central_id.length === 0) {
        self.units = [];
        return;
      }

      const centralIds = Array.isArray(self.users.central_id)
        ? self.users.central_id
        : [self.users.central_id];
      const params = centralIds.map((id) => `central_id[]=${id}`).join("&");
      const api = self.$store.state.api + "units?paginated=false&" + params;

      axios
        .get(api)
        .then((response) => {
          self.units = response.data;
        })
        .catch((error) => {
          self.$message(null, error.response?.data ?? error, "error");
        });
    },
    getUserUnits(userId) {
      const api = this.$store.state.api + "user_units/by-user/" + userId;

      axios
        .get(api)
        .then((response) => {
          this.users.unit_id = response.data.units.map((unit) => unit.id);
        })
        .catch((error) => {
          console.error("Erro ao buscar Unidades do usuário", error);
        });
    },
    getUserAgencies(userId) {
      const api = this.$store.state.api + "user_agencies/by-user/" + userId;

      axios
        .get(api)
        .then((response) => {
          this.users.central_id = response.data.centrals.map(
            (central) => central.id
          );
          // Filtra as unidades disponíveis pela(s) agência(s) do usuário
          this.getUnitsByCentral();
        })
        .catch((error) => {
          console.error("Erro ao buscar Unidades do usuário", error);
        });
    },
    uploadImage(e) {
      const image = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (e) => {
        this.previewImage = e.target.result;
        console.log(this.previewImage);
      };
    },
  },
  mounted: function () {
    const self = this;

    self.getCentrals();

    let id = self.$route.params.id;
    if (id) {
      self.change_password = false;
      self.getUsers(id);
      self.getUserUnits(id);
      // getUserAgencies dispara getUnitsByCentral após carregar a(s) agência(s)
      self.getUserAgencies(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}
.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}
.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important ;
}
.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>